import React from 'react';
import { Target, Eye, ClipboardCheck, Video, Users } from 'lucide-react';
const features = [{
  icon: Target,
  title: 'El Mapa del Tesoro (Pyramid Tracker)',
  description: 'Identifica exactamente en qué nivel está tu hijo y cuál es el siguiente paso real (Rec vs. Academy vs. Premier).'
}, {
  icon: Eye,
  title: 'Las 5 Métricas Invisibles',
  description: "Sabrás qué es el 'Scanning' y el 'IQ de Transición'. Si tu hijo domina esto, los scouts dejarán de mirar el marcador para mirarlo a ÉL."
}, {
  icon: ClipboardCheck,
  title: 'El Scorecard de Auditoría',
  description: 'Una tabla para que TÚ evalúes el partido de tu hijo como un profesional y detectes fugas de talento.'
}, {
  icon: Video,
  title: 'Highlight Reel de 60 Segundos',
  description: 'Cómo editar un video que los coaches de College NO borren. (Pista: Quita la música de reggaetón ahora mismo).'
}, {
  icon: Users,
  title: 'Networking Pro',
  description: "Plantillas de correo 'Cierra-Tratos' para contactar a Directores Técnicos sin parecer un padre intenso."
}];
export function WhatInsideSection() {
  return <section className="w-full bg-navy py-24 px-4" data-id="element-176">
      <div className="max-w-6xl mx-auto" data-id="element-177">
        <div className="text-center mb-16" data-id="element-178">
          <h2 className="text-3xl md:text-5xl font-headline font-bold text-white uppercase mb-4" data-id="element-179">
            ¿Qué Hay Dentro del Método?
          </h2>
          <p className="text-xl text-cyan font-medium" data-id="element-180">
            Esto no es teoría. Es un sistema de ejecución inmediata.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-181">
          {features.map((feature, index) => <div key={index} className={`bg-navy-light border border-white/5 p-8 rounded-xl hover:border-cyan/30 transition-all duration-300 hover:-translate-y-1 group ${index === 0 || index === 1 ? 'lg:col-span-3 lg:w-2/3 lg:mx-auto' : ''}`} data-id="element-182">
              <div className="bg-navy w-14 h-14 rounded-lg flex items-center justify-center mb-6 border border-white/10 group-hover:border-cyan/50 group-hover:shadow-[0_0_15px_rgba(0,212,255,0.2)] transition-all" data-id="element-183">
                <feature.icon className="w-7 h-7 text-cyan" data-id="element-184" />
              </div>
              <h3 className="text-xl font-headline font-bold text-white mb-3 group-hover:text-cyan transition-colors" data-id="element-185">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-186">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}